import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { InvoiceHistory, InvoiceHistoryRequestData, InvoiceSummaryAvisResponse, InvoiceSummaryDetailResponse } from './custom-user-payments.models';

@Injectable()
export class CustomUserPaymentsAdapter {

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  getUserPayments(): Observable<InvoiceHistory> {
    return this.http.get<InvoiceHistory>(
      this.occEndpoints.buildUrl('customUserPayments')
    );
  }

  searchUserPayments( invoiceHistoryRequestData: InvoiceHistoryRequestData): Observable<InvoiceHistory> {
    const dateFrom = invoiceHistoryRequestData.dateFrom;
    const dateTo = invoiceHistoryRequestData.dateTo;
    const invoiceNumber = invoiceHistoryRequestData.invoiceNumber;
    const articleNumber = invoiceHistoryRequestData.articleNumber;
    const adviceNumber = invoiceHistoryRequestData.adviceNumber;
    const onlyOpen = invoiceHistoryRequestData.onlyOpen;
    const referenceNumber = invoiceHistoryRequestData.referenceNumber;
    const amountFrom = invoiceHistoryRequestData.amountFrom;
    const amountTo = invoiceHistoryRequestData.amountTo;
    const orderType = invoiceHistoryRequestData.orderType;
    const bookingType = invoiceHistoryRequestData.bookingType;

    const params = {
      dateFrom,
      dateTo,
      invoiceNumber,
      articleNumber,
      adviceNumber,
      onlyOpen,
      referenceNumber,
      amountFrom,
      amountTo,
      orderType,
      bookingType
    };
    return this.http.get<InvoiceHistory>(
      this.occEndpoints.buildUrl('customSearchUserPayments', {queryParams: params})
    );
  }

  getUserPaymentsDetails(
    invoiceNumber: string,
    companyCode: string,
    bookingYear: string,
    bookingTime: string
  ): Observable<InvoiceSummaryDetailResponse>{
    const params = {
      invoiceNumber: invoiceNumber,
      companyCode: companyCode,
      bookingYear: bookingYear,
      bookingTime: bookingTime,
    };
    return this.http.get<InvoiceSummaryDetailResponse>(
      this.occEndpoints.buildUrl('customUserPaymentsDetails', {urlParams: params})
    );
  }

  getUserPaymentsAvis(
    avisNumber: string,
    avisDate: string
  ): Observable<InvoiceSummaryAvisResponse>{
    const params = {
      avisNumber: avisNumber,
      avisDate: avisDate
    };
    return this.http.get<InvoiceSummaryAvisResponse>(
      this.occEndpoints.buildUrl('customUserPaymentsAvis', {urlParams: params})
    );
  }
}
